<template>
	<div class="action-managment">
		<div class="warning-box">
			<img src="@/assets/images/iconPack/warning.svg" />
			<span class="mr-2">توجه</span>
			<ul>
				<li>
					جهت ایجاد برنامه روزانه شماره‌ی موبایل نیروی اجرایی و کد مشتری مورد نظر را در باکس‌های مربوطه
					وارد کنید و برای ثبت هر مورد دکمه‌ی [+] را بزنید.
				</li>
				<li>همچنین می‌توانید در صورت زیاد بودن تعداد برنامه‌ها، از بخش آپلود اکسل استفاده کنید.</li>
				<li>
					در صورت استفاده از بخش آپلود حتما از فایل نمونه استفاده کنید و سرستون های آنرا تغییر
					ندهید.
				</li>
			</ul>
		</div>
		<div class="card">
			<div class="card-body d-flex flex-column">
				<h5 class="mb-4">تعیین زمان و نوع برنامه</h5>
				<span>لطفا تاریخ اجرای این برنامه را انتخاب کنید.</span>
				<input type="text" :disabled="status" class="custom-input inputs" />
				<date-picker
					v-model="dataPicker"
					clearable
					format="YYYY-MM-DDTHH:mm:00"
					display-format="jMMMM jD"
					custom-input=".custom-input"
					:disabled="status"
				/>
				<div class="d-flex align-items-center mt-3">
					<input class="ml-3" type="checkbox" v-model="status" />
					<span>این برنامه تاریخ مشخصی برای اجرا ندارد.</span>
				</div>
				<hr />
				<div>
					<span>لطفا نوع برنامه خود را انتخاب کنید.</span>
					<div>
						<select v-model="visitTypeSelected" class="form-select inputs">
							<option v-for="visit in visitTypeList" :value="visit.id" :key="visit.id">
								{{ visit.verbose_name }}
							</option>
						</select>
					</div>
				</div>
				<hr />

				<div class="d-flex align-center">
					<input class="ml-3" type="checkbox" v-model="isLastDay" />
					ویزیت روز آخر
				</div>
			</div>
		</div>
		<div class="card">
			<div class="card-body">
				<PickAction @sendPhoneNumber="getPhoneNumber" />
			</div>
			<div class="button-container">
				<button :disabled="checkEmpty" @click="continueProcess" class="continue">مرحله بعد</button>
			</div>
		</div>
		<loading v-if="loading" />
	</div>
</template>
<script>
import PickAction from '../../components/pickAction/index.vue';
import Loading from '../../components/Loading/index.vue';

export default {
	components: {
		PickAction,
		Loading,
	},
	data() {
		return {
			dataPicker: '',
			phoneNumber: null,
			status: false,
			visitTypeList: [],
			visitTypeSelected: null,
			loading: false,
			isLastDay: false,
		};
	},
	mounted() {
		this.getVisitType();
	},
	computed: {
		checkEmpty() {
			if (
				this.phoneNumber &&
				this.phoneNumber.length &&
				this.visitTypeSelected !== null &&
				(this.dataPicker !== '' || this.status === true)
			) {
				return false;
			} else {
				return true;
			}
		},
	},
	methods: {
		getPhoneNumber(value) {
			this.phoneNumber = value;
		},
		async getVisitType() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.VISIT_TYPE + '?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.visitTypeList = res.data;
				this.visitTypeList;
			}
		},
		async continueProcess() {
			this.loading = true;
			// let popped = this.phoneNumber.pop();
			// ('sd',this.dataPicker);
			// (popped);
			this.phoneNumber.forEach((obj) => {
				obj.is_last_day = this.isLastDay;
			});
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.MULTI.CREATE_ACTION_PLAN +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{
					project: this.$STORE.state.userConfig.setProjectId,
					actions: this.phoneNumber,
					has_due_date: !this.status,
					due_date: this.dataPicker,
					visit_type: this.visitTypeSelected,
				},
			);
			if (res.status === 200) {
				this.loading = false;
				this.$router.push({ name: 'listActionPlan' });
			}
		},
		openLoading() {
			this.$refs.loading.open();
		},
	},
};
</script>
<style lang="scss" scoped>
.action-managment {
	width: 100%;
	padding: 24px;
	.warning-box {
		padding: 16px;
		color: #664d03;
		background: #fff3cd;
		li {
			margin: 0px 34px;
			list-style: disc;
		}
	}
	.card {
		border: none;
		margin-top: 50px;
		box-shadow: none;
		border-radius: 8px;
		padding: 24px;
		.inputs {
			margin-top: 16px;
			width: 25%;
			height: 38px;
			border: 1px solid #c4c4c4;
			padding: 0 9px;
			border-radius: 8px;
		}
	}
}
.button-container {
	display: flex;
	justify-content: flex-end;
	margin-top: 12px;
	.continue {
		border: none;
		background: #2d8b8b;
		padding: 8px;
		border-radius: 8px;
		color: #fff;
		margin-left: 8px;
		&:disabled {
			background: #f1f1f1;
			color: #535656;
			border-radius: 8px;
			border: none;
			padding: 8px;
		}
	}
}
</style>
<style>
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	border: none !important;
	border-radius: 0;
	font-family: 'IRANYekanfa';
}
.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
}
</style>
